// extracted by mini-css-extract-plugin
export var centerText = "_6y-8";
export var container = "_6y-0";
export var doughnutContainer = "_6y-7";
export var legend = "_6y-a";
export var legendItemColorDisplay = "_6y-b";
export var legendItemLabel = "_6y-d";
export var legendItemValue = "_6y-c";
export var lg = "_6y-5";
export var maxWidth = "_6y-9";
export var md = "_6y-4";
export var responsive = "_6y-6";
export var sm = "_6y-3";
export var xs = "_6y-2";
export var xxs = "_6y-1";